// extracted by mini-css-extract-plugin
export default {"newBalance":"Pay&transfer_newBalance__bXhZb","newType":"Pay&transfer_newType__HZJDU","radius":"Pay&transfer_radius__w8213","settingRadius":"Pay&transfer_settingRadius__M5Euw"};